import { render } from "./CreatePasswordForm.vue?vue&type=template&id=c91bb91a"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__